import { Danger, Error, Info, OkCircle } from '@atom-learning/icons'
import React, { useEffect } from 'react'

import { cn } from '~/styled'

import { Icon } from '../icon/Icon'
import { useSectionMessageContext } from './SectionMessageContext'

const themeIcons = {
  success: OkCircle,
  warning: Danger,
  error: Error,
  neutral: Info,
  info: Info
}

type SectionMessageIconProps = Partial<React.ComponentProps<typeof Icon>>

export const SectionMessageIcon = ({
  className,
  is,
  ...rest
}: SectionMessageIconProps): React.JSX.Element => {
  const { theme, setHasIcon } = useSectionMessageContext()

  useEffect(() => {
    setHasIcon(true)
    return () => setHasIcon(false)
  }, [setHasIcon])

  return (
    <Icon
      is={is || themeIcons[theme]}
      size="sm"
      {...rest}
      className={cn(
        'm-auto',
        'absolute',
        'left-4',
        'top-4',
        'text-current',
        className
      )}
    />
  )
}
